export const AI_SERVICE_PROMPTS = {
	GENERATOR_BY_PDF: 9,
	GENERATOR: 4,
	ADD_MORE_CHECKS: 5,
	ASSET_INSIGHTS: 6,
};
